import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SocialNetworks from './SocialNetworks';
import UserRoles from './UserRoles';
import UserSkills from './UserSkills';

import eyes from 'src/components/footer/img/eyes.svg';
import './leftBar.scss';

const editSvg = (<svg xmlns="http://www.w3.org/2000/svg" id="svg16" width="20" height="19.975"><defs id="defs4" /><g data-name="Layer 2" id="Layer_2" transform="translate(0 3.975)"><g id="g841" transform="matrix(1.35227 0 0 1.35227 0 -5.636)"><path transform="rotate(-45)" id="rect8" d="M-8.079 8.893h11.44v4.86h-11.44z" /><path className="cls-2" d="M14.525 3.628l-2.13-2.13a.93.93 0 0 0-1.31 0l-1.18 1.18 3.44 3.43 1.18-1.18a.93.93 0 0 0 0-1.3z" id="path10" fillRule="evenodd" /><path className="cls-2" d="M.012 15.268a.61.61 0 0 0 .72.72l3.28-.55-3.45-3.45z" id="path12" fillRule="evenodd" /></g></g></svg>);

class LeftBar extends Component {
  state = {
    arrowIsUp: false,
    leftBarExpand: false,
  }

  toggleWrap = key => {
    this.setState(state => ({
      [key]: !state[key]
    }));
  }

  resetPassword = (e) => {
    e.preventDefault();
    this.props.openResetPasswordModal();
  }

  render() {
    const { username } = this.props;
    return (
      <div className={this.state.leftBarExpand ? 'account__left-bar expand' : 'account__left-bar'}>
      
        <div className="text_with_arrow" onClick={() => {this.toggleWrap('arrowIsUp');this.toggleWrap('leftBarExpand')}}>
          <div className={this.state.arrowIsUp ? 'arrow-togle-btn up' : 'arrow-togle-btn'}/>
          <h2>Настройки аккаунта</h2>
        </div>
        <div className="left-bar__block">
          <div className="left-bar__avatar">
            <img src={eyes} width="35" height="35" alt="User avatar" />
          </div>
          <div className="left-bar__name">{username}
          <br />
          {/* <a className="change-photo" href="#">Сменить фото</a> */}
          </div>
        </div>

        <SocialNetworks editSvg={editSvg}/>
        <UserRoles editSvg={editSvg}/>
        <UserSkills editSvg={editSvg}/>

        <div className="left-bar__block left-bar__block-password">
          <button className="left-bar__password-btn" onClick={this.resetPassword}>
            ИЗМЕНИТЬ ПАРОЛЬ
          </button>
        </div>
        <div className="left-bar-overlay"></div>
      </div>
    );
  }
}

LeftBar.propTypes = {
  username: PropTypes.string.isRequired,
  openResetPasswordModal: PropTypes.func.isRequired,
}

export default LeftBar;


// WEBPACK FOOTER //
// ./src/components/Account/LeftBar/index.js